export default __webpack_public_path__ + "static/media/bannerLogo.41a05c94.png";